// ═══════════════════════════════════════════════════════════════════════════════
// Comment Validation Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { SUPPORTED_LANGUAGES } from '../constants/index.js';
import { COMMENT_TARGET_TYPE } from '../constants/index.js';
import { uuidSchema } from './common.schema.js';
// ── Create Comment Input Schema ──
export const createCommentInputSchema = z.object({
    targetType: z.enum([
        COMMENT_TARGET_TYPE.TASK_INSTANCE,
        COMMENT_TARGET_TYPE.RECEIPT,
    ], {
        error: 'Target type must be task_instance or receipt',
    }),
    targetId: uuidSchema,
    // Transport cap; server enforces actual max from system_settings.limits_by_level.commentMaxLength
    content: z
        .string()
        .min(1, 'Comment content is required')
        .max(4000, 'Comment exceeds maximum allowed length')
        .transform((val) => val.trim()),
});
// ── Comment Query Schema ──
export const commentQuerySchema = z.object({
    targetType: z.enum([
        COMMENT_TARGET_TYPE.TASK_INSTANCE,
        COMMENT_TARGET_TYPE.RECEIPT,
    ]),
    targetId: uuidSchema,
    viewerLanguage: z.enum(SUPPORTED_LANGUAGES).optional(),
});
// ── Comment ID Param Schema ──
export const commentIdParamSchema = z.object({
    id: uuidSchema,
});
//# sourceMappingURL=comment.schema.js.map